// src/cognito.ts
export const cognito = {
  region: "eu-west-2",
  userPoolId: "eu-west-2_nBtmwc3MJ",
  userPoolClientId: "3pipvu8jrnptpd5m1ni8j25p00",
  domain: "apikeymanager-prod.auth.eu-west-2.amazoncognito.com",
  redirectSignIn: "https://apikeymanager.addlee-prod.com/",
  redirectSignOut: "https://apikeymanager.addlee-prod.com/",
  scopes: ["openid", "email", "profile"],
};